const PageLoader = () => {
    return (
        <div
            style={{
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#f5f5f5'
            }}
        >
            <div className="loader"></div>
        </div>
    );
};

export default PageLoader;